import CareerPlanDocumentPage from "../_CareerPlanDocumentPage";

export default function EditCareerPlanDocumentPage() {
  return <CareerPlanDocumentPage mode="edit" />;
}
